import { ButtonCTA, SpinnerSmall, TextField } from 'components/ui';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmInvitationMutation } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';

export default function Invitation() {
  const formRef = useRef(null);
  const passwordFieldRef = useRef(null);
  const confirmPasswordFieldRef = useRef(null);
  const history = useHistory();

  const { query } = useParseURLQueryParams();

  const [confirmInvitation, { isLoading }] = useConfirmInvitationMutation();

  /** @param {*} event */
  async function handleOnSubmit(event) {
    event.preventDefault();

    const { password, name } = event.target;

    confirmInvitation({
      body: {
        name: name.value,
        password: password.value,
      },
      token: query.token,
      userId: query.user_id,
      storeName: query.store_name,
    }).finally(() => history.replace('/'));
  }

  function validatePassword() {
    if (
      // @ts-ignore
      passwordFieldRef.current.value !== confirmPasswordFieldRef.current.value
    ) {
      // @ts-ignore
      confirmPasswordFieldRef.current.setCustomValidity(
        'Passwords do not match. Try again'
      );
    } else {
      // @ts-ignore
      confirmPasswordFieldRef.current.setCustomValidity('');
    }
  }

  useEffect(() => {
    const inputs = document.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener(
        'invalid',
        () => {
          input.classList.add(
            'focus:ring-segments-at-risk',
            'focus:border-segments-at-risk'
          );
        },
        false
      );
      input.addEventListener('change', validatePassword);
    });
  }, []);

  return (
    <div className="px-5 pt-5 md:pt-24 lg:px-32">
      <div className="flex items-center -ml-1 lg:ml-0">
        <img
          width="40"
          height="40"
          src="/assets/logo-segments.png"
          alt="logo"
        />
        <h1 className="ml-1 text-base font-normal leading-7 md:text-2xl md:ml-3 tracking-segments_logo text-segments-dark">
          Segments
        </h1>
      </div>
      <div className="flex justify-center mx-auto md:w-segments-411px">
        <form
          className="mt-8 lg:mt-14 w-segments-411px"
          ref={formRef}
          onSubmit={handleOnSubmit}
        >
          <h1 className="text-2xl font-bold leading-9 ">
            You have been invited{' '}
            {query.store_name ? 'by ' + query.store_name : ''} to join Segments
          </h1>
          <div className="mt-9 lg:mt-12">
            <label htmlFor="name" className="block text-sm font-bold">
              Name
            </label>
            <TextField
              name="name"
              type="text"
              placeholder="Required"
              size="small"
              required
            />
          </div>

          <div className="mt-4">
            <label htmlFor="password" className="block text-sm font-bold">
              Password
            </label>
            <TextField
              ref={passwordFieldRef}
              name="password"
              type="password"
              placeholder="Required"
              required
            />
          </div>
          <div className="mt-4">
            <label
              htmlFor="confirm_password"
              className="block text-sm font-bold"
            >
              Confirm Password
            </label>
            <TextField
              ref={confirmPasswordFieldRef}
              name="confirm_password"
              type="password"
              placeholder="Required"
              required
            />
          </div>

          <div className="grid-cols-3 lg:grid mt-14 lg:space-x-9">
            <p className="col-span-2 lg:w-64 text-segments-13px">
              By registering, you agree to our{' '}
              <a
                href="https://tresl.co/terms"
                className="font-bold text-segments-link"
              >
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href="https://tresl.co/privacy"
                className="font-bold text-segments-link"
              >
                Privacy Policy
              </a>
            </p>
            <div className="mt-5 lg:mt-0">
              <ButtonCTA variant="main" type="submit" disabled={isLoading}>
                {isLoading ? <SpinnerSmall /> : 'Register'}
              </ButtonCTA>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
